import styled from 'styled-components';
import { tokens, ArrowBack, ArrowForward } from '@plataforma/components';
import { fonts, colors, grid } from '_/styles';

export const Button = styled.button`
  display: flex;
  align-self: flex-start;
  justify-content: space-between;
  align-items: center;
  font-family: inherit;
  border: 0;
  cursor: pointer;
  outline: none;
  appearance: none;
  background: none;
  max-width: 260px;
  height: 40px;
  padding: 0;
  margin-bottom: ${grid.small};
  ${({ width }) => width && `width: ${width}px;`}
`;

export const Label = styled.span`
  color: ${colors.baseElectricViolet};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.default};
`;

export const ArrowLeft = styled(ArrowBack)`
  color: ${colors.baseElectricViolet};
  width: 22px !important;
  height: 22px !important;
`;

export const ArrowRight = styled(ArrowForward)`
  color: ${colors.baseElectricViolet};
  width: 22px !important;
  height: 22px !important;
`;

export const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;
